/* =========================================================================================
  File Name: moduleSearch.js
  Description: Search Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Searchor: Pixinvent
  Searchor URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import state from './moduleSearchState.js';
import mutations from './moduleSearchMutations.js';
import actions from './moduleSearchActions.js';
import getters from './moduleSearchGetters.js';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
